import * as React from 'react'
import { Row, Col, Modal } from 'antd';
import * as _ from 'lodash';
import { useState, useContext } from 'react';
import { IExpenseTradeItemCreate } from 'src/services/interfaces/Expense/IExpenseTradeItemCreate';
import "./ExpenseBatchButton.scss"
import { IFileToUpload } from '../PbrCertificateUploader/PbrCertificateUploader';
import { ServiceContext } from 'src/services/provider/Service.provider';
import PbrProcessDocumentUploader from '../PbrProcessDocumentUploader/PbrProcessDocumentUploader';

interface IExpenseBatchButton {
    onChange: (list: IExpenseTradeItemCreate[]) => void;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    items: IExpenseTradeItemCreate[];
}

export const ExpenseBatchButton: React.FC<IExpenseBatchButton> = ({
    onChange,
    setLoading,
    items
}) => {
    const { expenseRequestService } = useContext(ServiceContext);

    const [listErrors, setListErrors] = useState<string[]>(undefined);

    const handleUpload = (file: IFileToUpload) => {
        setLoading(true);
        expenseRequestService
            .loadExpenseFromExcel(file)
            .then((resp) => {
                onChange(resp)
            })
            .catch((error) => {
                setListErrors(error?.response?.data?.InnerExceptions?.map(c => c.message))
            })
            .finally(() => setLoading(false));
    }


    return (
        <Row>
            <Col>
                <PbrProcessDocumentUploader
                    btnText={`Enviar Planilha`}
                    onChangeBase64={val => handleUpload(val)}
                    style={{ textAlign: "center" }}
                    name={"upload"}
                />
            </Col>
            <Modal
                title={"Erros ao processar Planilha"}
                visible={!_.isEmpty(listErrors)}
                onCancel={() => setListErrors(null)}
                footer={[]}
            >
                <ul className="bullet-list">
                    {listErrors?.map(e => (<>
                        <li>{e}</li>
                    </>))}
                </ul>
            </Modal>
        </Row>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseBatchButton/ExpenseBatchButton.tsx